import { createStyles } from '@mantine/core'

export default createStyles((theme, _params, getRef) => ({
  root: {},

  header: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },

  navs: {},
}))
